module.exports = __webpack_public_path__ + "static/media/FILMM2024.8bb3ffcf.pdf";